import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1295px;
  margin: 48px auto 0;
  position: relative;
  display: flex;
  justify-content: center;
  gap: 16px;

  @media (max-width: 1295px) {
    max-width: 100%;
    flex-direction: column;
    margin: 0 auto;
  }
`;

export const ContainerCol = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 38px;
  gap: 11px;
  @media screen and (max-width: 1024px) {
    justify-content: flex-start;
    margin-bottom: 16px;
  }
`;

export const Aside = styled.aside`
  max-width: 296px;
  width: 100%;
  border-radius: 8px;
  background-color: var(--white);
  padding: 32px 24px;
  z-index: 1;

  @media (max-width: 1295px) {
    /* display: none; */
    border-radius: 0;
    background-color: #ebf2ff;
    order: -1;
    max-width: 100%;
    padding: 12px 20px;

    button {
      display: none;
    }
  }
`;

export const ButtonValidation = styled.span`
  gap: 8px;
  background-color: transparent;
  color: var(--ins-blue);
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Subtitle = styled.h3`
  font-size: 20px;
  font-weight: 400;
  color: var(--gray-900);

  svg {
    display: none;
  }

  @media screen and (max-width: 1295px) {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 5px;
    background-color: var(--gray-100);
    border-radius: 4px;

    svg {
      display: block;
    }
  }
`;

export const Paragraph = styled.p`
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 30px;

  &.validationType {
    margin-bottom: 14px;
    font-weight: 600;
  }
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const ListItem = styled.li`
  margin-bottom: 20px;
  color: var(--gray-800);
  position: relative;
`;

export const Image = styled.img`
  position: absolute;
  top: 100px;
  left: 17%;
`;
